'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('../SvgIcon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortNeutral = function SortNeutral(props) {
	return _react2.default.createElement(
		_SvgIcon.SvgIcon,
		_extends({ viewBox: '0 0 26 26' }, props),
		_react2.default.createElement('path', { d: 'M13.004 1c-.5 0-.75.25-.75.25s-5.223 4-7.957 8c-.246.375-.375.75-.25 1.125s.625.625.996.625h15.914c.37 0 .87-.25.996-.625.125-.375 0-.75-.25-1.125-2.734-4-7.957-8-7.957-8s-.25-.25-.742-.25zm-7.96 14c-.372 0-.872.25-.997.625-.12.375 0 .75.25 1.125 2.734 4 7.957 8 7.957 8s.25.25.742.25c.5 0 .75-.25.75-.25s5.223-4 7.957-8c.25-.375.37-.75.25-1.125-.125-.375-.625-.625-.996-.625z' })
	);
};

exports.default = SortNeutral;